import { MutationTree } from 'vuex';
import * as MT from './mutationTypes';
import { IUserState } from './state';
import {
  OrganisationUser,
  Role,
  PaginationMeta,
  UserFilter,
  OrgUserStatistics
} from '../types';
import Organisation from '@/models/Organisation';

/*--------------------------------------------------/
 * User Mutations
 *--------------------------------------------------*/
export const UserMutations: IUserMutations = {
  [MT.SET_ORGANISATION_USERS]: (state: IUserState, funds: OrganisationUser[]) =>
    (state.organisationUsers = funds),
  [MT.SET_ORGANISATION_CLIENTS]: (state: IUserState, clients: Organisation[]) =>
    (state.organisationClients = clients),
  [MT.SET_ROLES]: (state: IUserState, roles: Role[]) => (state.roles = roles),
  [MT.SET_PAGINATION_META]: (
    state: IUserState,
    paginationMeta: PaginationMeta
  ) => (state.userPaginationMeta = paginationMeta),
  [MT.SET_CLIENT_PAGINATION_META]: (
    state: IUserState,
    clientPaginationMeta: PaginationMeta
  ) => (state.clientPaginationMeta = clientPaginationMeta),
  [MT.SET_APPLIED_USER_FILTER]: (
    state: IUserState,
    appliedFilter: UserFilter
  ) => (state.appliedFilter = appliedFilter),
  [MT.SET_ORGANISATION_USER_STATISTICS]: (
    state: IUserState,
    statistics: OrgUserStatistics
  ) => (state.statistics = statistics)
};

/*--------------------------------------------------/
 * User Mutations Tree Interface
 *--------------------------------------------------*/
export interface IUserMutations extends MutationTree<IUserState> {
  [MT.SET_ORGANISATION_USERS](
    state: IUserState,
    funds: OrganisationUser[]
  ): void;
  [MT.SET_ORGANISATION_CLIENTS](
    state: IUserState,
    clients: Organisation[]
  ): void;
  [MT.SET_ROLES](state: IUserState, roles: Role[]): void;
  [MT.SET_PAGINATION_META](
    state: IUserState,
    paginationMeta: PaginationMeta
  ): void;
  [MT.SET_CLIENT_PAGINATION_META](
    state: IUserState,
    clientPaginationMeta: PaginationMeta
  ): void;
  [MT.SET_APPLIED_USER_FILTER](
    state: IUserState,
    appliedFilter: UserFilter
  ): void;
  [MT.SET_ORGANISATION_USER_STATISTICS](
    state: IUserState,
    statistics: OrgUserStatistics
  ): void;
}
